import React from 'react';

const ToggleGroup = ({ label, options, value, onChange }) => (
  <div className="flex items-center justify-between py-3 border-b border-border last:border-0">
    <span className="text-foreground" style={{ fontFamily: '"IBM Plex Sans", sans-serif', fontSize: '0.9375rem' }}>{label}</span>
    <div className="flex rounded-lg border border-border overflow-hidden" style={{ background: 'var(--color-muted)' }}>
      {options?.map((opt) => (
        <button
          key={opt?.value}
          onClick={() => onChange(opt?.value)}
          className={`px-4 py-1.5 text-sm font-medium transition-colors ${
            value === opt?.value
              ? 'text-white' :'text-muted-foreground hover:text-foreground'
          }`}
          style={{
            fontFamily: '"IBM Plex Sans", sans-serif',
            fontSize: '0.8125rem',
            background: value === opt?.value ? 'var(--color-accent)' : 'transparent',
          }}
        >
          {opt?.label}
        </button>
      ))}
    </div>
  </div>
);

const SelectRow = ({ label, options, value, onChange }) => (
  <div className="flex items-center justify-between py-3 border-b border-border last:border-0">
    <span className="text-foreground" style={{ fontFamily: '"IBM Plex Sans", sans-serif', fontSize: '0.9375rem' }}>{label}</span>
    <select
      value={value}
      onChange={(e) => onChange(e?.target?.value)}
      className="px-3 py-1.5 rounded-lg border border-border bg-background text-foreground focus:outline-none focus:ring-2 transition-colors"
      style={{ fontFamily: '"IBM Plex Sans", sans-serif', fontSize: '0.8125rem', minWidth: '160px' }}
    >
      {options?.map((opt) => (
        <option key={opt?.value} value={opt?.value}>{opt?.label}</option>
      ))}
    </select>
  </div>
);

export default function DisplayTab({ prefs, onChange }) {
  const set = (key) => (val) => onChange({ ...prefs, [key]: val });

  const applyTheme = (theme) => {
    const root = document.documentElement;
    root.classList?.remove('light', 'dark');
    if (theme === 'light') root.classList?.add('light');
    else if (theme === 'dark') root.classList?.add('dark');
    onChange({ ...prefs, theme });
  };

  return (
    <div className="space-y-6">
      <div className="rounded-xl border border-border p-6" style={{ background: 'var(--color-card)' }}>
        <h3 className="text-foreground font-semibold mb-4" style={{ fontFamily: '"Outfit", sans-serif', fontSize: '1rem' }}>Moneda y Números</h3>
        <ToggleGroup label="Moneda predeterminada" options={[{ value: 'EUR', label: 'EUR €' }, { value: 'USD', label: 'USD $' }]} value={prefs?.currency || 'EUR'} onChange={set('currency')} />
        <ToggleGroup label="Formato de números" options={[{ value: 'EU', label: '1.000,00' }, { value: 'INT', label: '1,000.00' }]} value={prefs?.numberFormat || 'EU'} onChange={set('numberFormat')} />
        <SelectRow
          label="Formato de fecha"
          options={[{ value: 'DD/MM/YYYY', label: 'DD/MM/YYYY' }, { value: 'MM/DD/YYYY', label: 'MM/DD/YYYY' }, { value: 'YYYY-MM-DD', label: 'YYYY-MM-DD' }]}
          value={prefs?.dateFormat || 'DD/MM/YYYY'}
          onChange={set('dateFormat')}
        />
        <ToggleGroup label="Unidad de peso" options={[{ value: 't', label: 'Toneladas (t)' }, { value: 'kg', label: 'Kilogramos (kg)' }]} value={prefs?.weightUnit || 't'} onChange={set('weightUnit')} />
        <SelectRow
          label="Decimales en precios"
          options={[{ value: '0', label: '0 decimales' }, { value: '1', label: '1 decimal' }, { value: '2', label: '2 decimales' }]}
          value={prefs?.decimalPrecision || '2'}
          onChange={set('decimalPrecision')}
        />
      </div>
      <div className="rounded-xl border border-border p-6" style={{ background: 'var(--color-card)' }}>
        <h3 className="text-foreground font-semibold mb-4" style={{ fontFamily: '"Outfit", sans-serif', fontSize: '1rem' }}>Idioma y Apariencia</h3>
        <ToggleGroup
          label="Idioma de la interfaz"
          options={[{ value: 'es', label: 'Español' }, { value: 'en', label: 'English' }]}
          value={prefs?.language || 'es'}
          onChange={set('language')}
        />
        <div className="flex items-center justify-between py-3">
          <div>
            <span className="text-foreground" style={{ fontFamily: '"IBM Plex Sans", sans-serif', fontSize: '0.9375rem' }}>Tema de la aplicación</span>
            <p className="text-muted-foreground" style={{ fontFamily: '"IBM Plex Sans", sans-serif', fontSize: '0.75rem' }}>Se aplica inmediatamente</p>
          </div>
          <div className="flex rounded-lg border border-border overflow-hidden" style={{ background: 'var(--color-muted)' }}>
            {[{ value: 'light', label: '☀️ Claro' }, { value: 'dark', label: '🌙 Oscuro' }, { value: 'system', label: '💻 Sistema' }]?.map((opt) => (
              <button
                key={opt?.value}
                onClick={() => applyTheme(opt?.value)}
                className={`px-3 py-1.5 text-sm font-medium transition-colors ${
                  (prefs?.theme || 'system') === opt?.value ? 'text-white' : 'text-muted-foreground hover:text-foreground'
                }`}
                style={{
                  fontFamily: '"IBM Plex Sans", sans-serif',
                  fontSize: '0.8125rem',
                  background: (prefs?.theme || 'system') === opt?.value ? 'var(--color-accent)' : 'transparent',
                }}
              >
                {opt?.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
